@let currentItemDraft = itemDraft();
@let currentErrors = itemDraftErrors();

<section class="wishlist-create-items-step" aria-label="Pierwsze prezenty">
  @if (items().length === 0) {
    <ui-card class="wishlist-create-items-step__empty">
      <span class="wishlist-create-items-step__empty-icon" aria-hidden="true">
        <ui-library-icon name="other" fallbackLabel="Prezent" />
      </span>
      <strong>Nie musisz dodawać prezentów teraz.</strong>
      <span>Wishlistę możesz uzupełnić później.</span>
    </ui-card>
  } @else {
    <ul class="wishlist-create-items-step__list" aria-label="Dodane prezenty">
      @for (item of items(); track item.id) {
        <li class="wishlist-create-items-step__row">
          <span class="wishlist-create-items-step__row-icon" aria-hidden="true">
            <ui-library-icon name="other" fallbackLabel="Prezent" />
          </span>
          <span class="wishlist-create-items-step__row-main">
            <strong>{{ item.title }}</strong>
            @if (item.description) {
              <small>{{ item.description }}</small>
            }
            <span class="wishlist-create-items-step__row-meta">
              <span>{{ priorityLabels[item.priority] }}</span>
              @if (item.priceAmount) {
                <span>{{ item.priceAmount }} PLN</span>
              }
            </span>
          </span>
          <ui-icon-button
            variant="soft"
            [ariaLabel]="'Usuń ' + item.title"
            (pressed)="handleItemRemoveSelected(item.id)"
          >
            x
          </ui-icon-button>
        </li>
      }
    </ul>
  }

  @if (!itemDraftOpen()) {
    <ui-action-card
      class="wishlist-create-items-step__open"
      title="Dodaj prezent"
      description="Dodaj pierwszą propozycję do wishlisty"
      (selected)="handleItemDraftOpenSelected()"
    >
      <span uiActionCardLeading aria-hidden="true">+</span>
    </ui-action-card>
  } @else {
    <ui-card class="wishlist-create-items-step__form">
      <ui-input
        label="Nazwa prezentu"
        name="giftTitle"
        placeholder="np. LEGO Friends Domek na drzewie"
        [value]="currentItemDraft.title"
        [required]="true"
        [errorText]="currentErrors.itemTitle"
        (valueChange)="handleItemTitleChange($event)"
      />

      <ui-input
        label="Opis"
        name="giftDescription"
        placeholder="np. Wersja z wieżyczką"
        [value]="currentItemDraft.description"
        [errorText]="currentErrors.itemDescription"
        (valueChange)="handleItemDescriptionChange($event)"
      />

      <div class="wishlist-create-items-step__priority">
        <span class="wishlist-create-items-step__field-label">Priorytet</span>
        <div
          class="wishlist-create-items-step__priority-list"
          role="group"
          aria-label="Priorytet prezentu"
        >
          @for (priority of priorityOptions(); track priority.id) {
            <ui-chip
              [active]="currentItemDraft.priority === priority.id"
              [tone]="
                currentItemDraft.priority === priority.id
                  ? 'primary'
                  : 'neutral'
              "
              (selected)="handleItemPriorityChange(priority.id)"
            >
              {{ priority.label }}
            </ui-chip>
          }
        </div>
      </div>

      <ui-input
        label="Link do sklepu"
        name="giftStoreUrl"
        type="url"
        placeholder="https://..."
        [value]="currentItemDraft.storeUrl"
        [errorText]="currentErrors.itemUrl"
        (valueChange)="handleItemStoreUrlChange($event)"
      />

      <ui-input
        label="Cena orientacyjna"
        name="giftPrice"
        inputMode="decimal"
        placeholder="np. 199"
        [value]="currentItemDraft.priceAmount"
        [errorText]="currentErrors.itemPrice"
        (valueChange)="handleItemPriceAmountChange($event)"
      />

      <ui-textarea
        label="Notatka prywatna właściciela"
        name="giftPrivateNote"
        placeholder="np. najlepiej niebieska wersja"
        [value]="currentItemDraft.privateNote"
        [errorText]="currentErrors.itemPrivateNote"
        [rows]="2"
        helperText="Goście nie zobaczą tej notatki."
        (valueChange)="handleItemPrivateNoteChange($event)"
      />

      <div class="wishlist-create-items-step__actions">
        <ui-button
          variant="secondary"
          (pressed)="handleItemDraftCloseSelected()"
        >
          Anuluj
        </ui-button>
        <ui-button
          [disabled]="itemDraftSubmitDisabled()"
          (pressed)="handleItemAddSelected()"
        >
          Dodaj prezent
        </ui-button>
      </div>
    </ui-card>
  }
</section>
